// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/wake-turbulence-landing-avoidance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/wake-turbulence-landing-avoidance/wake-turbulence-landing-avoidance.js';

mount([g0]);
